import { FC } from 'react';
import { Typography } from '@material-ui/core';
import styled from '@emotion/styled';
import { SPACING_LARGE } from '../../../constant/spacing';

type Props = {
  className?: string;
};

const Footer: FC<Props> = ({ className }) => {
  return (
    <Root className={className}>
      <Typography variant="caption">Copyright © 2019 Kaizen Platform, Inc. All rights reserved.</Typography>
    </Root>
  );
};

const Root = styled('footer')({
  padding: SPACING_LARGE,
});

export default Footer;
